import { render, staticRenderFns } from "./InputCustom.vue?vue&type=template&id=5c59f3d0&scoped=true"
import script from "./InputCustom.vue?vue&type=script&lang=js"
export * from "./InputCustom.vue?vue&type=script&lang=js"
import style0 from "./InputCustom.vue?vue&type=style&index=0&id=5c59f3d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c59f3d0",
  null
  
)

export default component.exports